import PropTypes from "prop-types";
import { forwardRef, useImperativeHandle, useState } from "react";

import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import AssignAgentsForm from "./AssignAgentsForm";

const AssignAgentsModal = forwardRef(({ onSuccess }, ref) => {
  const [open, setOpen] = useState(false);
  const [twilioPhoneNumberIds, setTwilioPhoneNumberIds] = useState([]);
  const [userIds, setUserIds] = useState([]);

  useImperativeHandle(ref, () => ({
    open: (nextPhoneNumberIds, nextUserIds) => {
      setTwilioPhoneNumberIds(nextPhoneNumberIds);
      setUserIds(nextUserIds);
      setOpen(true);
    },
  }));

  const handleSuccess = () => {
    setOpen(false);
    onSuccess?.();
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogTitle>Assign Agents</DialogTitle>
        {open && (
          <AssignAgentsForm
            twilioPhoneNumberIds={twilioPhoneNumberIds}
            userIds={userIds}
            onSuccess={handleSuccess}
          />
        )}
      </DialogContent>
    </Dialog>
  );
});

AssignAgentsModal.displayName = "AssignAgentsModal";

AssignAgentsModal.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

export default AssignAgentsModal;
